// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4e0feac3","496":"78c86954","703":"d231d398"}[chunkId] + ".chunk.js";
};